import { IUserData } from 'apps/fleet-planner/context'
import { SETTINGS_TIME_FORMAT } from 'apps/fleet-planner/types'

export const getUserNamesFromEntity = (
  userData: IUserData = {}
): { firstName: string; lastName: string; fullName: string } => {
  const { user } = userData
  const { firstName = '', fullName = '', lastName = '' } = user || {}
  return {
    firstName,
    lastName,
    fullName,
  }
}

export const getUserSettingsFromUser = (
  userData: IUserData = {}
): { timeFormat: SETTINGS_TIME_FORMAT } => {
  const { user } = userData
  const { settings } = user || {}
  const { timeFormat = SETTINGS_TIME_FORMAT.STANDARD } = settings || {}
  return {
    timeFormat,
  }
}
